import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ConfigurationService } from '../../configuration/configuration-service';
import { CronologiaStatoDTO } from '../models/cronologiaStato-dto';
import { Paths } from './Paths';

@Injectable({
  providedIn: 'root'
})
export class PagamentiService {

  constructor(private paths: Paths, private http: HttpClient) { }

  getCronologiaStati$(idPagamento: string): Observable<Array<CronologiaStatoDTO>> {
    const url: string = this.paths.get_V1_CRONOLOGIA_STATI(idPagamento);
    return this.http.get<Array<CronologiaStatoDTO>>(url).pipe(shareReplay());
  }




}
